export default __webpack_public_path__ + "static/media/9f92d736159141d9d63db68e450e84bc.svg";